import script from "./AddInvoiceFileField.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddInvoiceFileField.vue?vue&type=script&lang=ts&setup=true"

import "./AddInvoiceFileField.vue?vue&type=style&index=0&id=2c8995d6&lang=sass"

const __exports__ = script;

export default __exports__